import { useEffect, useState } from 'react';

import styled from 'styled-components';

import {
    SupplyOrdersWithSupplierProductsInfoUpdatedOrCreatedSubscription,
    useGetManualSupplyOrdersQuery,
    useGetManualSupplyOrderSupplierProductsStockVariationQuery,
    SupplyOrderState,
} from 'data/__generated__';
import { ManualSupplyOrdersForm } from './ManualSupplyOrdersForm';
import { Loader } from 'components/Loader';
import { SUPPLY_ORDERS_WITH_SUPPLIER_PRODUCTS_INFO_UPDATED_OR_CREATED_SUBSCRIPTION } from 'data/subscriptions/supplyOrder';

export const ManualSupplyOrders = () => {
    const [trelloCardInfoPopup, setTrelloCardInfoPopup] = useState(false);

    const {
        loading: manualSupplyOrdersLoading,
        data: manualSupplyOrdersData,
        error: manualSupplyOrdersError,
        subscribeToMore,
    } = useGetManualSupplyOrdersQuery();

    const {
        data: supplyOrderSupplierProductsStockVariationData,
        loading: supplyOrderSupplierProductsStockVariationLoading,
        error: supplyOrderSupplierProductsStockVariationError,
    } = useGetManualSupplyOrderSupplierProductsStockVariationQuery();

    useEffect(() => {
        const unsubscribe = subscribeToMore<SupplyOrdersWithSupplierProductsInfoUpdatedOrCreatedSubscription>({
            document: SUPPLY_ORDERS_WITH_SUPPLIER_PRODUCTS_INFO_UPDATED_OR_CREATED_SUBSCRIPTION,
            updateQuery: (prevData, { subscriptionData }) => {
                if (!subscriptionData || !prevData) return prevData;
                const updatedSupplyOrders = subscriptionData.data.supplyOrdersUpdatedOrCreated;
                const updatedSupplyOrderIds = updatedSupplyOrders.map((supplyOrder) => supplyOrder._id);
                return {
                    manualSupplyOrders: [
                        ...prevData.manualSupplyOrders.filter(
                            (supplyOrder) => !updatedSupplyOrderIds.includes(supplyOrder._id),
                        ),
                        ...updatedSupplyOrders.filter(
                            (supplyOrder) =>
                                supplyOrder.nextOrderDate && supplyOrder.state === SupplyOrderState.Created,
                        ),
                    ],
                };
            },
        });

        return () => unsubscribe();
    }, [subscribeToMore]);

    if (manualSupplyOrdersLoading) {
        return (
            <Container>
                <Loader />
            </Container>
        );
    }

    if (!manualSupplyOrdersLoading && (manualSupplyOrdersError || !manualSupplyOrdersData)) {
        throw new Error('Une erreur est survenue lors de la récupération des cartes achats');
    }

    return (
        <Container>
            <ManualSupplyOrdersForm
                manualSupplyOrders={manualSupplyOrdersData?.manualSupplyOrders || []}
                stockVariationData={
                    supplyOrderSupplierProductsStockVariationData?.manualSupplyOrderSupplierProductsStockVariation
                }
                stockVariationLoading={supplyOrderSupplierProductsStockVariationLoading}
                stockVariationError={supplyOrderSupplierProductsStockVariationError}
                trelloCardInfoPopup={trelloCardInfoPopup}
                setTrelloCardInfoPopup={setTrelloCardInfoPopup}
            />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    overflow: hidden;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;
